<h1 class="cg-h1">{{ 'am.pageTitle' | translate }}</h1>

<cigna-process-steps
  class="cg-hide-for-print"
  [steps]="steps$ | async"
  [activeStep]="(steps$ | async)?.length - 1"
  [hiddenSteps]="hiddenSteps$ | async"
></cigna-process-steps>

<div *ngIf="(selectedUserType$ | async) === EXISTING_USER">
  <h3 class="cg-h3 cg-hide-for-print">
    {{ 'am.receive.existing.header' | translate }}
  </h3>
  <p class="cg-margin-top-none cg-margin-bottom-xl cg-hide-for-print">
    {{ 'am.receive.existing.subHeader' | translate }}
  </p>
  <p class="cg-show-for-print cg-print-page-break-after">
    Please see the below pages for each user who you have edited access for
  </p>
</div>

<div *ngIf="(selectedUserType$ | async) === NEW_USER">
  <h3 class="cg-h3 cg-hide-for-print">
    {{ 'am.receive.new.header' | translate }}
  </h3>
  <p class="cg-margin-top-none cg-margin-bottom-xl">
    {{ 'am.receive.new.subHeader' | translate }}
  </p>
  <!-- <p><strong>{{'am.receive.new.listHeader' | translate}}</strong></p> -->
  <ol class="cg-ordered-list">
    <li class="cg-ordered-list__item">
      {{ 'am.receive.new.listItem1' | translate }}
    </li>
    <li class="cg-ordered-list__item">
      {{ 'am.receive.new.listItem2' | translate }}
    </li>
    <li class="cg-ordered-list__item">
      {{ 'am.receive.new.listItem3' | translate }}
    </li>
    <li class="cg-ordered-list__item">
      {{ 'am.receive.new.listItem4' | translate }}
    </li>
    <li class="cg-ordered-list__item">
      {{ 'am.receive.new.listItem5' | translate }}
    </li>
  </ol>
  <p class="cg-hide-for-print">
    <strong>{{ 'am.receive.new.tableHeader' | translate }}</strong>
  </p>
  <p class="cg-show-for-print cg-print-page-break-after">
    Please see the below pages for each user who you have added
  </p>
</div>

<div class="cg-margin-bottom-md">
  <cigna-table-review-confirm
    [users]="selectedUsers$ | async"
    [userType]="selectedUserType$ | async"
    [shouldShowPrefLob]="(amLob$ | async) !== LOB_DENTAL && (prefLob$ | async)"
    [selectedPrintEmailUsers]="selectedEmailPrintusers$ | async"
    [isVendorSuccess]="isVendorSuccess$ | async"
    (userSelected)="onUserSelectChange($event)"
    (usersToggleAll)="onUsersToggleAll($event)"
    tableView="confirm"
  >
  </cigna-table-review-confirm>
</div>

<div *ngIf="(isVendorSuccess$ | async) === false">
  <div class="cg-error-msg cg-margin-bottom-md cg-margin-top-md">
    <cigna-icon type="exclamation-circle"></cigna-icon>
    <span data-spa-service-error>{{ 'am.receive.error' | translate }}</span>
  </div>
</div>

<div class="cg-margin-bottom-md cg-button-group cg-hide-for-print">
  <button
    cignaButton="primary"
    [disabled]="(selectedEmailPrintusers$ | async)?.length < 1"
    (click)="print()"
    data-test="print-button"
  >
    {{ 'am.receive.printBtn' | translate }}
  </button>
  <a cignaButton="link" routerLink="./../" data-test="manage-access-home-link">
    {{ 'am.receive.backBtn' | translate }}
  </a>
</div>
